/**
 * Autocomplete only. An expenditure position stores whatever name the user picked or typed.
 */
export const expenditureSuggestions: string[] = [
  'Miete',
  'Nebenkosten',
  'Private Krankenversicherung',
  'Sonstige Darlehen',
  'Versicherungsprämien',
  'Sonstige',
]
